import { isNil, find, isPlainObject, isObject, isEmpty, get, cloneDeep } from 'lodash'
import { FIRST_PARTY_TYPE, THIRD_PARTY_TYPES } from '@/utils/constants'

function getReturnFirstPartyValue(data) {
    return !isNil(
        find(FIRST_PARTY_TYPE, type => {
            return data.type === type
        })
    )
}

function getReturnThirdPartyValue(data) {
    return !isNil(
        find(THIRD_PARTY_TYPES, type => {
            return data.type === type
        })
    )
}

const hasFirstParty = formulae => {
    //no data, no chocolat
    if (isNil(formulae) || isEmpty(formulae)) return false

    //check if there's a type (data === obj && has a type), if so return whereas type is 1st party or not
    if (!isNil(get(formulae, 'type', null))) {
        return getReturnFirstPartyValue(formulae)
    }
    //(data === array) || (data === obj && !has type)
    let valueToReturn = null
    for (const _formula in formulae) {
        const formula = formulae[_formula]
        //check if data is string (=> no formula) or obj || array (=> formula)
        if (isObject(formula)) {
            //check if there's a type (data === obj && has a type), if so return whereas type is 1st party or not
            if (get(formula, 'type', null)) {
                valueToReturn = getReturnFirstPartyValue(formula)
                if (valueToReturn) break
            } else {
                //!type => isObject ? no need do dig further : isArray ==> start again!
                valueToReturn = isPlainObject(formula) ? false : hasFirstParty(formula)
                if (valueToReturn) break
            }
        }
    }
    return valueToReturn
}

const hasThirdParty = formulae => {
    //no data, no chocolat
    if (isNil(formulae) || isEmpty(formulae)) return false

    //check if there's a type (data === obj && has a type), if so return whereas type is 1st party or not
    if (!isNil(get(formulae, 'type', null))) {
        return getReturnThirdPartyValue(formulae)
    }
    //(data === array) || (data === obj && !has type)
    let valueToReturn = null
    for (const _formula in formulae) {
        const formula = formulae[_formula]
        //check if data is string (=> no formula) or obj || array (=> formula)
        if (isObject(formula)) {
            //check if there's a type (data === obj && has a type), if so return whereas type is 1st party or not
            if (get(formula, 'type', null)) {
                valueToReturn = getReturnThirdPartyValue(formula)
                if (valueToReturn) break
            } else {
                //!type => isObject ? no need do dig further : isArray ==> start again!
                valueToReturn = isPlainObject(formula) ? false : hasThirdParty(formula)
                if (valueToReturn) break
            }
        }
    }
    return valueToReturn
}

// Remove this piece of code once max_recency is fixed on back-end/API side
const getMaxRecency = formula => {
    const formulaClone = cloneDeep(formula)
    let recencyList = []
    if (!formulaClone) return 30
    if (Array.isArray(formulaClone)) {
        if (formulaClone[0] === '&') {
            formulaClone.shift()
            formulaClone.forEach(box => {
                if (Array.isArray(box)) {
                    box.forEach(item => {
                        if (typeof item === 'object' && item.recency) {
                            recencyList.push(item?.recency)
                        }
                    })
                } else {
                    if (box?.recency) recencyList.push(box?.recency)
                }
            })
        } else {
            formulaClone.map(item => {
                if (typeof item === 'object' && item.recency) recencyList.push(parseInt(item?.recency))
            })
        }
        return Math.max(...recencyList) ? Math.max(...recencyList) : 30
    } else return parseInt(formulaClone.recency) || 30
}

export default { hasFirstParty, hasThirdParty, getMaxRecency }
